import React, { useState } from 'react';
import './BringerofWorlds.css';

function BringerofWorlds() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('community'); // 'community' or 'find-team'
  const [projectPrompt, setProjectPrompt] = useState('');
  const [suggestedTeam, setSuggestedTeam] = useState(null);
  const [userProfile] = useState({
    level: 1,
    skills: [],
    specialties: [],
    availability: 'medium',
    relationshipNetwork: {
      acquaintances: [],
      friends: [],
      closeFriends: [],
      family: []
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.length === 5) {
      setIsAuthenticated(true);
    } else {
      setError('Access code must be 5 characters long');
    }
  };

  const calculateTeamMatch = (project, potentialTeam) => {
    let matchScore = 0;
    const skillMatchWeight = 3;
    const relationshipWeight = {
      acquaintance: 1,
      friend: 2,
      closeFriend: 3,
      family: 4
    };
    const availabilityWeight = {
      low: 1,
      medium: 2,
      high: 3
    };

    potentialTeam.forEach(member => {
      // Skill match calculation
      const skillMatches = member.skills.filter(skill => 
        project.requiredSkills.includes(skill)
      ).length;
      matchScore += skillMatches * skillMatchWeight;

      // Relationship weight
      matchScore += relationshipWeight[member.relationship];

      // Availability weight
      matchScore += availabilityWeight[member.availability];

      // Level compatibility bonus
      if (Math.abs(member.level - userProfile.level) <= 2) {
        matchScore += 2;
      }
    });

    return matchScore;
  };

  const generateTeam = (projectDescription) => {
    // AI-powered team generation logic
    const requiredSkills = extractSkillsFromPrompt(projectDescription);
    const potentialTeam = findPotentialTeamMembers(requiredSkills);
    const scoredTeam = potentialTeam.map(member => ({
      ...member,
      matchScore: calculateTeamMatch({ requiredSkills }, [member])
    })).sort((a, b) => b.matchScore - a.matchScore);

    setSuggestedTeam(scoredTeam.slice(0, 5)); // Top 5 matches
  };

  const extractSkillsFromPrompt = (prompt) => {
    // AI-powered skill extraction from project description
    // This would be connected to a more sophisticated NLP model
    return prompt.toLowerCase().split(' ').filter(word => 
      ['muay', 'thai', 'music', 'ai', 'cybersecurity', 'training', 'production'].includes(word)
    );
  };

  const findPotentialTeamMembers = (requiredSkills) => {
    // This would be connected to a database of users
    // For now, returning mock data
    return [
      {
        id: 1,
        name: 'John Doe',
        level: 3,
        skills: ['muay thai', 'music production'],
        relationship: 'friend',
        availability: 'high',
        matchScore: 0
      },
      // Add more mock team members
    ];
  };

  if (!isAuthenticated) {
    return (
      <div className="bringer-container">
        <div className="login-container">
          <div className="community-link" onClick={() => setActiveTab('community')}>
            Community Access
          </div>
          <form onSubmit={handleSubmit}>
            <label className="login-label">
              Enter any 5-character code
            </label>
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              placeholder="Enter 5 characters"
              autoComplete="off"
            />
            {error && <div className="error-message">{error}</div>}
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="bringer-container">
      <header className="bringer-header">
        <h1>Community Hub</h1>
        <p>Connect, Collaborate, Create</p>
      </header>

      <div className="main-content">
        <div className="tabs">
          <button 
            className={`tab ${activeTab === 'community' ? 'active' : ''}`}
            onClick={() => setActiveTab('community')}
          >
            Community
          </button>
          <button 
            className={`tab ${activeTab === 'find-team' ? 'active' : ''}`}
            onClick={() => setActiveTab('find-team')}
          >
            Find Team
          </button>
        </div>

        {activeTab === 'community' ? (
          <div className="community-section">
            <h2>Community Members</h2>
            <div className="level-progression">
              <h3>Your Level: {userProfile.level}</h3>
              <div className="progress-bar">
                <div className="progress" style={{ width: `${(userProfile.level / 10) * 100}%` }}></div>
              </div>
            </div>
            <div className="skills-section">
              <h3>Your Skills</h3>
              <div className="skills-grid">
                {userProfile.skills.map(skill => (
                  <div key={skill} className="skill-card">
                    {skill}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="find-team-section">
            <h2>Find Your Team</h2>
            <div className="project-prompt">
              <textarea
                placeholder="Describe your project and required skills..."
                value={projectPrompt}
                onChange={(e) => setProjectPrompt(e.target.value)}
              />
              <button onClick={() => generateTeam(projectPrompt)}>
                Generate Team
              </button>
            </div>
            {suggestedTeam && (
              <div className="suggested-team">
                <h3>Suggested Team</h3>
                <div className="team-grid">
                  {suggestedTeam.map(member => (
                    <div key={member.id} className="team-member-card">
                      <h4>{member.name}</h4>
                      <p>Level: {member.level}</p>
                      <p>Match Score: {member.matchScore}</p>
                      <div className="skills">
                        {member.skills.map(skill => (
                          <span key={skill} className="skill-tag">{skill}</span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default BringerofWorlds; 